module.exports = __webpack_public_path__ + "img/chevron-down.551c598f.svg";